import { store } from 'src/store/index.js';

const Notify = {
  create(notification, errorResponse = undefined) {
    store.dispatch('notification/createNotification', {
      notification: notification,
      error: errorResponse,
    });
  },
};

export default Notify;
